<script setup lang="ts">
/*
 * FILE: unified_ui/src/components/TopNav.vue
 * PURPOSE: Desktop top tab bar — glass/Telegram style. Orders first (home/dashboard).
 *          Hidden on mobile.
 */
import { useRoute } from 'vue-router'
import { RouterLink } from 'vue-router'
import { useIdentityStore } from '@/stores/identity'
import ThemeToggle from './ThemeToggle.vue'

defineProps<{ greeting: string }>()

const identity = useIdentityStore()

const tabs = [
  { to: '/orders', label: 'КП' },
  { to: '/chat',   label: 'Чат' },
  { to: '/about',  label: 'О нас' },
]

const route = useRoute()
function isActive(to: string) {
  return route.path === to || route.path.startsWith(to + '/')
}
</script>

<template>
  <header
    class="sticky top-0 z-30 border-b nav-glass pt-safe"
  >
    <div class="mx-auto flex max-w-5xl items-center justify-between px-4 md:px-6 py-2.5 md:py-3">
      <div class="flex items-baseline gap-1.5 md:gap-2 min-w-0">
        <span class="text-sm md:text-base font-semibold text-brand-500 truncate">КИБЕР Маркет</span>
        <span
          v-if="identity.devTest"
          class="rounded-md bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800 dark:bg-amber-900/40 dark:text-amber-300"
          data-testid="devtest-badge"
        >
          dev test
        </span>
        <span v-if="greeting !== 'КИБЕР Маркет'" class="text-xs md:text-sm text-ink-500 truncate">— {{ greeting }}</span>
      </div>
      <div class="flex items-center gap-2">
        <nav class="hidden md:flex items-center gap-1">
          <RouterLink
            v-for="tab in tabs"
            :key="tab.to"
            :to="tab.to"
            class="rounded-xl px-4 py-2 text-sm font-medium transition-colors duration-150"
            :class="
              isActive(tab.to)
                ? 'bg-brand-500 text-white shadow-sm'
                : 'text-ink-600 hover:bg-ink-100/60'
            "
          >
            {{ tab.label }}
          </RouterLink>
        </nav>
        <ThemeToggle />
      </div>
    </div>
  </header>
</template>
